// ================================================================
// Drag Utility — منطق drag مشترک با پشتیبانی موس + تاچ
// ================================================================

/**
 * یه element رو قابل drag می‌کنه
 * @param {HTMLElement} handle — المان که کاربر روش می‌کشه
 * @param {object} options
 *   - onStart(e): قبل از شروع drag
 *   - onMove(dx, dy, e): در حین حرکت
 *   - onEnd(wasDragged, e): بعد از پایان
 *   - threshold: حداقل پیکسل برای محسوب شدن drag (پیش‌فرض 5)
 */
export function makeDraggable(handle, options = {}) {
  const { onStart, onMove, onEnd, threshold = 5 } = options;

  let startX = 0;
  let startY = 0;
  let dragging = false;
  let movedDistance = 0;
  let wasDragged = false;

  function pointerStart(e) {
    if (e.touches && e.touches.length > 1) return;
    e.preventDefault();
    const point = e.touches ? e.touches[0] : e;
    startX = point.clientX;
    startY = point.clientY;
    dragging = true;
    movedDistance = 0;
    wasDragged = false;
    onStart?.(e);
  }

  function pointerMove(e) {
    if (!dragging) return;
    const point = e.touches ? e.touches[0] : e;
    const dx = point.clientX - startX;
    const dy = point.clientY - startY;
    movedDistance = Math.abs(dx) + Math.abs(dy);

    if (movedDistance > threshold) {
      wasDragged = true;
    }

    onMove?.(dx, dy, e);
  }

  function pointerEnd(e) {
    if (!dragging) return;
    dragging = false;
    onEnd?.(wasDragged, e);
  }

  handle.addEventListener('mousedown', pointerStart);
  document.addEventListener('mousemove', pointerMove);
  document.addEventListener('mouseup', pointerEnd);

  handle.addEventListener('touchstart', pointerStart, { passive: false });
  document.addEventListener('touchmove', pointerMove, { passive: false });
  document.addEventListener('touchend', pointerEnd);

  // تابع cleanup
  return function destroy() {
    handle.removeEventListener('mousedown', pointerStart);
    document.removeEventListener('mousemove', pointerMove);
    document.removeEventListener('mouseup', pointerEnd);
    handle.removeEventListener('touchstart', pointerStart);
    document.removeEventListener('touchmove', pointerMove);
    document.removeEventListener('touchend', pointerEnd);
  };
}
